import { cloneDeep, filter, get, pick, remove } from 'lodash';

// 获取练习的做题步骤
export const getStepListForPractice = practice => {
  const { questionBackup } = practice;
  const { questions } = questionBackup;
  const stepList = [];
  questions.forEach((question, index) => {
    stepList.push({
      type: 'Base',
      questionType: question.type,
      questionId: question.id,
      id: index + 1,
      questionIndex: index + 1,
      questionCount: questions.length,
    });
  });

  stepList.push({
    type: 'Base',
    id: questions.length + 1,
    questionType: 'End',
  });

  return stepList;
};

// 添加附加信息
const addExtraInfo = stepList => {
  let newStepList = cloneDeep(stepList);
  // 计算题目数量
  let readingCount = 0;
  let listeningCount = 0;
  let speakingCount = 0;
  let writingCount = 0;
  newStepList.forEach(step => {
    if (step.sectionId === 1) {
      readingCount += 1;
    }

    if (step.sectionId === 2) {
      listeningCount += 1;
    }

    if (step.sectionId === 3) {
      speakingCount += 1;
    }

    if (step.sectionId === 4) {
      writingCount += 1;
    }
  });

  let readingIndex = 0;
  let listeningIndex = 0;
  let speakingIndex = 0;
  let writingIndex = 0;
  newStepList = newStepList.map((step, index) => {
    const obj = {
      id: index + 1,
    };

    if (step.sectionId === 1) {
      readingIndex += 1;
      obj.questionIndex = readingIndex;
      obj.questionCount = readingCount;
    }

    if (step.sectionId === 2) {
      listeningIndex += 1;
      obj.questionIndex = listeningIndex;
      obj.questionCount = listeningCount;
    }

    if (step.sectionId === 3) {
      speakingIndex += 1;
      obj.questionIndex = speakingIndex;
      obj.questionCount = speakingCount;
    }

    if (step.sectionId === 4) {
      writingIndex += 1;
      obj.questionIndex = writingIndex;
      obj.questionCount = writingCount;
    }

    return Object.assign({}, step, obj);
  });

  return newStepList;
};

// 获取测评的做题步骤
export const getStepListForTest = test => {
  const stepList = [];
  const { questionBackup, examId } = test;
  const { subjects, practices, questions } = questionBackup;
  for (let i = 0; i < subjects.length; i += 1) {
    const subjectPractices = subjects[i].practices;
    for (let k = 0; k < subjectPractices.length; k += 1) {
      const practice = filter(practices, { id: subjectPractices[k] })[0];
      filter(questions, { practiceId: practice.id }).length > 0 &&
      filter(questions, { practiceId: practice.id }).forEach(question => {
        stepList.push({
          type: 'Test',
          sectionId: i + 1,
          questionType: question.type,
          questionId: question.id,
          practiceId: practice.id,
          examId,
        });
      });
    }
  }

  stepList.push({
    type: 'Test',
    questionType: 'End',
    examId,
  });
  return addExtraInfo(stepList);
};

// 添加 完整版入学测评附加信息
const addExtraInfo1 = stepList => {
  let newStepList = cloneDeep(stepList);
  newStepList = newStepList.map((step, index) => {
    const obj = {
      id: index + 1,
    };
    return Object.assign({}, step, obj);
  });
  return newStepList;
};

// 获取完整版入学测评 做题步骤

export const getStepListForFullTest = test => {
  const stepList = [];
  const { questionBackup, examId } = test;
  const { subjects, practices, questions } = questionBackup;
  let questionIndex;
  for (let i = 0; i < subjects.length; i += 1) {
    const subjectPractices = subjects[i].practices;
    questionIndex = 1;
    if (i === 3 && examId !== 56) {
      stepList.push({
        type: 'FullTest',
        sectionId: 7,
        questionType: 'Resting',
        examId,
        isOtherPage: false,
      });
    }
    stepList.push({
      type: 'FullTest',
      sectionId: i,
      questionType: 'Welcome',
      examId,
      isOtherPage: true,
    });
    if (i === 3 && examId !== 56) {
      stepList.push({
        type: 'FullTest',
        sectionId: i,
        questionType: examId === 2 ? 'SpeakingTest' : 'ListeningTest',
        examId,
        isOtherPage: true,
      });
    } else if (i === 4 && examId !== 56) {
      stepList.push({
        type: 'FullTest',
        sectionId: i + 1,
        questionType: examId === 1 ? 'SpeakingTest' : 'ListeningTest',
        examId,
        isOtherPage: true,
      });
    }
    for (let k = 0; k < subjectPractices.length; k += 1) {
      const practice = filter(practices, { id: subjectPractices[k] })[0];
      questions.forEach(question => {
        if (question.practiceId === practice.id) {
          stepList.push({
            type: 'FullTest',
            sectionId: i + 1,
            questionType: question.type,
            questionId: question.id,
            practiceId: practice.id,
            examId,
            questionIndex,
            questionCount: filter(questions, { practiceId: practice.id }).length,
            isOtherPage: false,
          });
          questionIndex += 1;
        }
      });
    }
  }

  stepList.push({
    type: 'FullTest',
    questionType: 'End',
    sectionId: 6,
    examId,
  });
  return addExtraInfo1(stepList);
};

// 获取服务端的answer
export const getServerAnswer = (questions, exerciseId) => {
  const answers = questions.map(question => {
    const answer = {
      questionType: question.type,
      exerciseId,
      questionId: question.id,
      userAnswers: [],
    };
    question.materials && question.materials.map(material => {
      if (get(material, 'userAnswer.answer') && JSON.stringify(get(material, 'userAnswer.answer')) !== '[]') {
        const userAnswer = pick(material.userAnswer,
          ['correct', 'answerId', 'questionMaterialId', 'answer']);
        answer.userAnswers.push(userAnswer);
      }
      return false;
    });
    if (JSON.stringify(answer.userAnswers) === '[]') return false;
    return answer;
  });
  remove(answers, answer => answer === false)

  return answers;
}




// WEBPACK FOOTER //
// ./src/utils/step.js